import Vue from 'vue'
import App from './App.vue'
import { router } from './router'
import store from './store'
import '@/assets/main.less'
import Vant from 'vant'
import 'vant/lib/index.css'
import VueQrcodeReader from 'vue-qrcode-reader'
import { Dialog } from 'vant'
import Moment from 'moment'

Vue.use(VueQrcodeReader)
Vue.use(Vant)
Vue.config.productionTip = false
Vue.use(Dialog)
Vue.prototype.moment = Moment // 引用时间控件

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app')
